import { Maybe, TokenBalance } from '../../../../../../graphql/generated/graphql'
import { DRIP_TOKEN_ADDRESS, DripTokenModule } from './drip'

import { NATIVE_ZERO_ADDRESS } from '@spritz-finance/sdk/dist/supportedTokens'
import { NATIVE_ADDRESS_OTHER } from '@spritz-finance/sdk'
import { EVMNativeTokenModule } from './evmNativeToken'
import { ERC20TokenModule } from './erc20Token'

export const getTokenModule = (token: Maybe<TokenBalance>, allTokens: TokenBalance[]) => {
    switch (token?.address) {
        case DRIP_TOKEN_ADDRESS:
            return new DripTokenModule(
                token!,
                allTokens.find((t) => t.symbol === 'BNB')
            )
        case NATIVE_ZERO_ADDRESS:
        case NATIVE_ADDRESS_OTHER:
            return new EVMNativeTokenModule(token)
        default:
            return new ERC20TokenModule(token!)
    }
}
